// extracted by mini-css-extract-plugin
export var buttonContainer = "timeline-intro-module--buttonContainer--Bffil";
export var darkBg = "timeline-intro-module--darkBg--6lpAP";
export var intro = "timeline-intro-module--intro--MmSm0";
export var lightBg = "timeline-intro-module--lightBg--0fvS6";
export var scrollContainer = "timeline-intro-module--scrollContainer--arIxy";
export var textAndScroll = "timeline-intro-module--textAndScroll--a3Pag";
export var textContainer = "timeline-intro-module--textContainer--DDP-X";